export default {
  loading: {
    id: 'spinner',
    defaultMessage: 'Loading',
  },
}
